<template>
    <div class="bg-image-blur-underlay">
        <div class="default-bg">
        </div>
        <p class="default-bg-text" :style="{ opacity: (barScale - 0.05) * 0.052 }">TOKOYAMI TOWA</p>
        <template v-for="(item, index) in timelineData" :key="`bg-${index}`">
            <img v-if="item.type === 'live' && item.image" class="default-image" :src="item.image"
                :class="{ 'bg-visible': bgImageVisibility[index] }">
        </template>
    </div>
    <div class="container" ref="container">
        <div class="timeline-sidebar" ref="sidebar">
            <div class="timeline-bar">
                <div style="position: relative; width: 100%; height: 100%;">
                    <div class="timeline-bar-fill"
                        :style="{ height: (barScale * 0.5 + endProgress * 0.3) * 100 + '%' }">
                        <div class="timeline-bar-tip">
                            <img class="star-base" :src="starBaseSvg" alt="">
                            <img class="star-outline" :src="starOutlineSvg" alt="">
                        </div>
                    </div>
                    <div class="timeline-bar-empty" :style="{ transform: `scaleY(${barScale})` }">
                    </div>
                </div>
            </div>
        </div>
        <div class="main-content">
            <div class="title-frame">
                <div>
                    <h3>Tokoyami Towa</h3>
                    <h1>音楽活動<span>の</span>軌跡</h1>
                    <div class="bar-container">
                        <div class="text">SINCE 2020</div>
                        <div class="bar"></div>
                    </div>
                </div>
            </div>
            <div class="timeline-frame">
                <div v-for="(item, index) in timelineData" :key="index" class="card" :data-index="index"
                    :class="{ live: item.type === 'live', badge: item.badge }"
                    :style="{ '--badge-label': item.badge ? `'${item.badge}'` : '' }">
                    <span class="card-date">{{ item.date }}</span>
                    <div class="card-body">
                        <div :class="{ 'card-flex': !(item.type === 'live' && this.isMobile) }">
                            <div v-if="item.image" class="card-thumbnail"
                                :class="{ 'img-live': this.isMobile && item.type === 'live' }">
                                <img :src="item.image" alt="thumbnail">
                            </div>
                            <div class="card-info">
                                <h3 class="card-title">{{ item.title }}</h3>
                                <p class="card-description" v-if="item.type !== 'event' || item.description">{{
                                    item.description }}</p>
                                <div class="card-link-container" v-if="!this.isMobile">
                                    <router-link v-if="item.param" :to="`/view?${item.param}`" class="card-link">
                                        Towa Song DBで再生
                                    </router-link>
                                    <a v-if="item.link" :href="item.link" class="card-link" target="_blank"
                                        rel="noopener">
                                        {{ item.type === 'live' ? '特設サイトへ' : item.type === 'release' ? 'リリースページ' :
                                            'YouTube'
                                        }}
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="card-link-container" v-if="this.isMobile">
                            <router-link v-if="item.param" :to="`/view?${item.param}`" class="card-link">
                                Towa Song DBで再生
                            </router-link>
                            <a v-if="item.link" :href="item.link" class="card-link" target="_blank" rel="noopener">
                                {{ item.type === 'live' ? '特設サイトへ' : item.type === 'release' ? 'リリースページ' :
                                    'YouTube'
                                }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="end-frame" ref="endFrame">
                <div class="dot-card">
                    <div class="dot-container">
                        <div class="dot"></div>
                        <div class="dot"></div>
                        <div class="dot"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import config from '../assets/data/songs.js'
import timelineData from '../assets/data/timeline.js'
import releases from '../assets/data/releases.js';

export default {
    name: 'TimelineView',
    data() {
        return {
            config: config,
            timelineData: timelineData,
            releases: releases.releases,
            barScale: 0,
            bgImageVisibility: {},
            endProgress: 0,
            isMobile: window.innerWidth <= 600,
            starBaseSvg: require('../assets/images/star_base.svg'),
            starOutlineSvg: require('../assets/images/star_outline.svg')
        }
    },
    mounted() {
        const localeMap = { ja_JP: 'ja', en_US: 'en', kr_KR: 'kr' }
        const key = localeMap[this.$i18n.locale] || 'ja'
        document.title = "Timeline | " + config.siteTitle[key]
        window.addEventListener('scroll', this.handleScroll)
        this.cardObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                const card = entry.target
                const isLive = card.classList.contains('live')
                const ratio = entry.intersectionRatio

                if (ratio >= 0.8) {
                    card.classList.add('card-visible')
                    if (!isLive) this.cardObserver.unobserve(card)
                }

                if (isLive) {
                    const index = parseInt(card.dataset.index)
                    if (ratio >= 0.8) {
                        this.bgImageVisibility[index] = true
                    } else if (ratio <= 0.5) {
                        this.bgImageVisibility[index] = false
                    }
                }
            })
        }, { threshold: [0, 0.5, 0.8] })
        this.$refs.container?.querySelectorAll('.card').forEach(card => {
            this.cardObserver.observe(card)
        })
        this.handleScroll()
        window.addEventListener('resize', () => {
            this.isMobile = window.innerWidth <= 600
        })
        this.timelineData.forEach((item, index) => {
            if (item.type === 'release') {
                const release = this.releases.find(r => r.name === item.title)
                if (release) {
                    this.timelineData[index].image = release.artworkUrl
                    this.timelineData[index].link = release.releaseLink
                    this.timelineData[index].date = release.releaseDate
                }
            }
        })
        this.timelineData = [...this.timelineData].sort((a, b) => a.date.localeCompare(b.date))
    },
    beforeUnmount() {
        window.removeEventListener('scroll', this.handleScroll)
        this.cardObserver?.disconnect()
    },
    methods: {
        handleScroll() {
            const titleFrame = this.$refs.container?.querySelector('.title-frame')
            if (titleFrame) {
                const threshold = titleFrame.offsetHeight * 0.4
                this.barScale = Math.max(0.05, Math.min(1, Math.max(0, window.scrollY / threshold)))
            }
            const endFrame = this.$refs.endFrame
            if (endFrame) {
                const rect = endFrame.getBoundingClientRect()
                const vh = window.innerHeight
                const visible = Math.max(0, Math.min(rect.bottom, vh) - Math.max(rect.top, 0))
                const ratio = visible / rect.height
                this.endProgress = Math.min(1, Math.max(0, (ratio - 0.5) / 0.5))
            }
        }
    }
}
</script>

<style scoped>
.bg-image-blur-underlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
}

.default-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(135deg, #190a2c 0%, #1d1126 50%, #0d0a19 100%);
    opacity: 1;
    z-index: -3;
}

.default-bg-text {
    color: #fff;
    font-size: 8rem;
    font-weight: bold;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    text-align: center;
    transform: translate(-50%, -50%);
    opacity: 0.05;
    z-index: -2;
    transition: opacity 0.3s ease-out;
}

.default-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    filter: blur(8px) brightness(0.5);
    transform: scale(1.05);
    z-index: -1;
    opacity: 0;
    transition: opacity 1.0s ease-in-out;
}

.default-image.bg-visible {
    opacity: 1;
}

.container {
    max-width: 1112px;
    margin: 0 auto;
    padding: 0 2rem;
    color: #fff;
    display: flex;
}

.timeline-sidebar {
    width: 20px;
    flex-shrink: 0;
    position: relative;
}

.main-content {
    flex: 1;
    min-width: 0;
}

.card {
    position: relative;
    margin: 48px 8px;
    background: rgba(19, 9, 31, 0.72);
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 12px;
    padding: 16px;
    backdrop-filter: blur(4px);
    max-width: 600px;
    z-index: 20;
    opacity: 0;
    transform: translateY(24px);
    transition: opacity 0.6s ease, transform 0.6s ease;
}

.card.live {
    margin: 192px 8px;
    border-color: rgba(192, 132, 252, 0.5);
    box-shadow: 0 0 12px rgba(192, 132, 252, 0.3), 0 0 32px rgba(192, 132, 252, 0.15);
    max-width: 800px;
}

.card.badge::after {
    content: var(--badge-label, '');
    position: absolute;
    top: -11px;
    right: 12px;
    font-size: 0.65rem;
    font-weight: 700;
    letter-spacing: 0.12em;
    color: #0e0a1a;
    background: linear-gradient(90deg, #c084fc, #a855f7);
    padding: 2px 10px;
    border-radius: 4px;
    box-shadow: 0 0 8px rgba(192, 132, 252, 0.6);
}

.card.card-visible {
    opacity: 1;
    transform: translateY(0);
}

.card-date {
    display: block;
    font-size: 0.85rem;
    font-weight: 600;
    color: #c084fc;
    letter-spacing: 0.08em;
    margin-bottom: 12px;
}

.card-flex {
    display: flex;
    gap: 16px;
    align-items: flex-start;
}

.card-thumbnail {
    width: 96px;
    height: 96px;
    flex-shrink: 0;
    border-radius: 8px;
    overflow: hidden;
    background: rgba(255, 255, 255, 0.06);
}

.card.live .card-thumbnail {
    aspect-ratio: 16/9;
    width: auto;
    /* height: 144px; */
}

.card-thumbnail img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

.card-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-width: 0;
}

.card-title {
    font-size: 1rem;
    font-weight: 600;
    margin: 0;
    line-height: 1.4;
}

.card-description {
    font-size: 0.9rem;
    color: rgba(255, 255, 255, 0.8);
    margin: 8px 0;
    min-height: 20px;
    flex-grow: 1;
}

.card-link-container {
    display: flex;
    gap: 12px;
    margin-top: 8px;
}

.card-link {
    display: inline-flex;
    align-items: center;
    align-self: flex-start;
    font-size: 0.8rem;
    color: #c084fc;
    text-decoration: none;
    border: 1px solid rgba(192, 132, 252, 0.4);
    border-radius: 6px;
    padding: 5px 12px;
    transition: background 0.2s, border-color 0.2s;
}

.card-link:hover {
    background: rgba(192, 132, 252, 0.15);
    border-color: rgba(192, 132, 252, 0.75);
}

.card::before {
    content: '';
    position: absolute;
    left: calc(-24px - 8px);
    top: 32px;
    transform: translateY(-50%);
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #c084fc;
    box-shadow: 0 0 10px rgba(192, 132, 252, 0.8);
}

.timeline-bar {
    position: sticky;
    top: 0;
    width: 3px;
    height: 100vh;
    pointer-events: none;
}

.timeline-bar-fill {
    position: absolute;
    width: 100%;
    height: 0%;
    transition: height 0.3s ease-out;
    background: linear-gradient(to bottom, #5b2d82, #9b59b6);
    overflow: visible;
}

.timeline-bar-empty {
    position: absolute;
    width: 100%;
    height: 100%;
    transform-origin: left top;
    transition: transform 0.3s ease-out;
    background: rgba(255, 255, 255, 0.12);
}

.timeline-bar-tip {
    position: absolute;
    bottom: 0;
    left: 50%;
    width: 24px;
    height: 24px;
    transform: translate(-50%, 50%);
    z-index: 30;
    pointer-events: none;
}

.timeline-bar-tip img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: block;
}

.star-outline {
    animation: starSpin 3s linear infinite;
}

@keyframes starSpin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
}

.title-frame {
    height: calc(90vh - 56px);
    box-sizing: border-box;
    display: flex;
    align-items: center;
    margin-left: 8px;
    width: 90%;
    container-type: inline-size;
}

.title-frame > div {
    width: 100%;
}

.title-frame h3 {
    font-size: clamp(0.8rem, 3cqw, 1.5rem);
    color: #c084fc;
    margin: 0 0 8px 0;
    text-transform: uppercase;
}

.title-frame h1 {
    font-size: clamp(2rem, 6cqw, 4rem);
    font-weight: bold;
    margin: 0;
    line-height: 1.2;
}

.title-frame h1 span {
    color: rgb(206, 206, 206);
    font-weight: normal;
}

.title-frame .bar-container {
    display: flex;
    align-items: center;
    margin-top: 8px;
    gap: 14px;
}

.title-frame .bar-container .text {
    font-size: 0.75rem;
    color: rgba(192, 132, 252, 0.65);
    letter-spacing: 0.22em;
    font-weight: 400;
    white-space: nowrap;
}

.title-frame .bar-container .bar {
    flex: 1;
    height: 2px;
    margin-top: 2px;
    align-self: center;
    background: linear-gradient(90deg, rgba(168, 85, 247, 0.8), rgba(168, 85, 247, 0.05));
    scale: 0 1;
    transform-origin: left center;
    animation: lineUo 1s ease-out forwards;
}

.end-frame {
    margin-top: 96px;
    height: 600px;
}

.dot-card {
    margin: 0 8px;
    max-width: 600px;
    padding: 20px 16px;
    display: flex;
    justify-content: center;
}

.dot-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 60px;
}

.dot-container .dot {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #c084fc;
    box-shadow: 0 0 10px rgba(192, 132, 252, 0.8);
}

.dot-container .dot:nth-child(2) {
    opacity: 0.4;
    box-shadow: none;
}

.dot-container .dot:nth-child(3) {
    opacity: 0.15;
    box-shadow: none;
}

@keyframes lineUo {
    from {
        scale: 0 1;
    }
    to {
        scale: 1 1;
    }
}

@media (max-width: 720px) {
    .default-bg-text {
        font-size: 6rem;
    }
}

@media (max-width: 600px) {
    .default-bg-text {
        font-size: 4rem;
    }

    .container {
        padding: 0 1rem;
    }

    .timeline-bar {
        left: 8px;
    }

    .card-thumbnail.img-live {
        width: 100%;
        height: auto;
        margin-bottom: 12px;
    }
}
</style>